var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c(_vm.statusCom,{tag:"component",attrs:{"is-xiaoman-type":_vm.verifyType===_vm.XIAOMAN_VERTIFY,"message":_vm.verifyErrorMessage,"auth-path":_vm.authPath,"close":_vm.isClose,"onchange":_vm.handleClose,"verify-type":_vm.verifyType,"ali-vertify":_vm.ALI_VERTIFY}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }